var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"user-guide"}},[_c('Documentation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }